import React from 'react';
import { CardTrioCard } from '../CardTrio/CardTrioCard';
import './RHBlock.scss';

export class ResourceHubBlock {
    id: string;
    title: string;
    subtitle: string;
    cards: CardTrioCard[] = [];
    type = `rh_block`;
    accent: boolean;
}

export const RHBlock = ({ node }: { node: ResourceHubBlock }) => {
    return (
        <section className={`rh__block ${node.accent ? `accent` : ``}`}>
            <div className="kite-container">
                <h2 id={node.title.toLowerCase().replace(/ /g, `-`)}>
                    {node.title}
                </h2>
                <div
                    className="subtitle"
                    dangerouslySetInnerHTML={{ __html: node.subtitle }}
                ></div>
                <ul>
                    {node.cards.map((card) => (
                        <CardTrioCard key={card.id} card={card} />
                    ))}
                </ul>
            </div>
        </section>
    );
};
